module.exports = __webpack_public_path__ + "img/biological_hazard.cfca783a.svg";